module.exports = __webpack_public_path__ + "static/media/cancelChipFilterIcon.94aa401b.svg";